import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ButtonDisablerService } from '../../../store/services/button-disabler.service';
import { UtilitiesService } from 'app/store/services/utilities.servive';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, OnDestroy {
  @Input() text: string;
  @Input() route: string | any[];
  @Input() Click: () => void;
  @Input() color: ButtonColor | string;
  @Input() size: ButtonSize | string = ButtonSize.SMALL;
  @Input() icon: IconProp;
  @Input() disabled: boolean;
  @Input() initiallyDisabled: boolean = false;
  @Input() style: 'outline' | 'filled' | 'dialog-filled' | 'rounded';
  @Input() loaderObservable: Observable<boolean>;
  @Input() observeApi: boolean = false;
  @Input() id: string;
  @Input() locked: boolean = false;
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
  showLoadingIcon: boolean;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly buttonDisablerService: ButtonDisablerService,
    private readonly utilitiesService: UtilitiesService
  ) {

  }

  onButtonClick(event) {
    if (this.disabled) {
      return;
    }
    if (this.observeApi) {
      this.showLoadingIcon = true;
      this.buttonDisablerService.trigger(this.id, true, this.locked);
    }
    if (this.Click) {
      this.Click.call(null, event, this);
    }

    this.clicked.emit(event);
  }

  release(): void {
    this.buttonDisablerService.trigger(this.id, false);
  }

  lock(): void {
    this.buttonDisablerService.trigger(this.id, true, true);
  }

  makeRandom(length: number = 10) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  ngOnInit() {
    if (this.disabled !== undefined && this.observeApi && !this.initiallyDisabled) {
      this.showLoadingIcon = this.disabled;
    }
    if (!this.id) {
      this.id = btoa((new Date()).toISOString() + this.text + this.makeRandom());
    }
    if (this.loaderObservable) {
      this.loaderObservable.pipe(takeUntil(this.destroy$)).subscribe(
        state => (this.showLoadingIcon = state),
        () => (this.showLoadingIcon = false),
        () => {
          this.showLoadingIcon = false;
          this.changeDetectorRef.detectChanges();
        },
      );
    }

    if (this.observeApi) {
      this.buttonDisablerService.register(this.id);
      this.buttonDisablerService.wait(this.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(state => {
          this.showLoadingIcon = state;
          this.disabled = state; 
          this.changeDetectorRef.detectChanges();
        });
      }
    }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.buttonDisablerService.remove(this.id);
  }

  getTestId(): string {
    if(this.text) {
      return this.utilitiesService.getTestIdProp(`${this.text}-button`);
    }

    if (this.id) {
      return this.utilitiesService.getTestIdProp(`${this.id}-button`);
    }

    return this.utilitiesService.getTestIdProp(`${this.makeRandom()}-button`);
  }
}
